module.exports = __webpack_public_path__ + "img/title-video-placeholder@1x.df3f869a.jpg";